var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h47v47H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#CDE1E8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m7.988 22.079 13.675-6.837c-.563 2.621-.684 5.841-.684 8.259 0 2.415.121 5.637.684 8.258L7.988 24.923c-1.172-.587-1.172-2.26 0-2.844m17.03-6.819c.486 1.616.809 4.524.809 8.24 0 3.717-.323 6.625-.808 8.241-.485-1.616-.808-4.524-.808-8.24 0-3.717.323-6.625.808-8.241m10.063 23.21-7.677-3.84c1.405-2.656 1.653-7.697 1.653-11.13 0-3.433-.248-8.473-1.653-11.13l7.832-3.916c10.602 15.57.674 28.914-.155 30.016m11.04 5.52-8.018-4.01c2.173-3.113 10.589-17.153-.039-32.94l8.057-4.028A1.59 1.59 0 0 0 44.7.168L.88 22.078c-1.173.586-1.173 2.258 0 2.845L44.7 46.83a1.59 1.59 0 1 0 1.422-2.842",
    mask: "url(#b)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngle);
export default __webpack_public_path__ + "static/media/icon_angle.5f7a99ad6bddb2613ab46c85e0c535c4.svg";
export { ForwardRef as ReactComponent };